import React, { useState } from 'react';
import { Grid } from '@mui/material';

import Layout from 'layouts/production/Pages/All/Layout';
import SearchBar from 'layouts/production/Pages/All/SearchBar';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import PinnedProductions from 'layouts/production/Pages/All/PinnedProductions/index.js';
import ViewToggle from 'layouts/production/Pages/All/ViewToggle';
import FilterPanel from 'layouts/production/Pages/All/FilterPanel';
import { SearchProvider } from 'layouts/production/Pages/SearchProvider';
import SyncIcon from '@mui/icons-material/Sync';
import AaroSyncDialog from 'layouts/production/Components/AaroSyncDialog';

export default function Productions() {
    const [openSyncDialog, setOpenSyncDialog] = useState(false);

    return (
        <SearchProvider>
            <Layout>
                <Grid container spacing={3}>
                    <Grid size={12}>
                        <MDBox
                            color="white"
                            bgColor="dark"
                            variant="gradient"
                            borderRadius="lg"
                            shadow="lg"
                            opacity={1}
                            p={2}
                        >
                            <Grid
                                container
                                spacing={3}
                                sx={{
                                    alignItems: 'center',
                                }}
                            >
                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 12,
                                    }}
                                >
                                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                                        <MDBox flexGrow={1}>
                                            <SearchBar />
                                        </MDBox>
                                        <MDButton
                                            startIcon={<SyncIcon sx={{ fontSize: '1rem' }} />}
                                            variant="contained"
                                            onClick={() => setOpenSyncDialog(true)}
                                            size="small"
                                            color="info"
                                            sx={{
                                                whiteSpace: 'nowrap',
                                                fontSize: '0.8rem',
                                                padding: '4px 12px',
                                                borderRadius: 1.5,
                                                ml: 1,
                                                textTransform: 'none',
                                                boxShadow: 'none',
                                            }}
                                        >
                                            Aaro Sync
                                        </MDButton>
                                    </MDBox>
                                </Grid>
                            </Grid>
                        </MDBox>
                    </Grid>
                    <Grid size={12}>
                        <PinnedProductions />
                    </Grid>
                    <Grid size={12}>
                        <FilterPanel />
                    </Grid>
                    <Grid size={12}>
                        <ViewToggle />
                    </Grid>
                </Grid>

                {/* AARO Sync Dialog */}
                {openSyncDialog && <AaroSyncDialog open={openSyncDialog} onClose={() => setOpenSyncDialog(false)} />}
            </Layout>
        </SearchProvider>
    );
}
